import React from 'react'

const RegisterDesignPopup = (props) => {
    const { SetStatus } = props;
  return (
    <div>
        <div className="avnet-modal modal-630 register-design-popup">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                

                        <button type="button" className="close" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                            document.getElementById('BOMStickyHeader').style.zIndex = 999
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading ps-4 pe-4">
                           Register Design
                        </h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="text-start mb-3 m-l-25">
                         
                            How do you want to proceed?
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary minw-auto"
                                onClick={() => {
                                    SetStatus(false)
                                    document.getElementById('BOMStickyHeader').style.zIndex = 999
                                }}
                            >
                               CANCEL
                            </button>
                            
                            <a href="https://fioritest.emea.avnet.com/sap/bc/ui5_ui5/ui2/ushell/shells/abap/FioriLaunchpad.html#Z_DRMS_PROJECT-create" target="_blank" className="font-bold bs5 btn btn-primary minw-auto"
                            > CREATE NEW PROJECT </a>
                            <a href="https://fioritest.emea.avnet.com/sap/bc/ui5_ui5/ui2/ushell/shells/abap/FioriLaunchpad.html#Z_DRMS_PROJECT-display" target="_blank" className="font-bold bs5 btn btn-primary minw-auto"
                            > ATTACH TO EXISTING PROJECT </a>
                        </div>
                    </div>
                </div>
            </div>
      
    </div>
  )
}

export default RegisterDesignPopup
